import type { RuntimeConfig } from './runtime-config';
import { useRuntime } from './use-runtime';

export function useRuntimeConfig(): RuntimeConfig {
  return useRuntime().config;
}
